import { render } from "./page.vue?vue&type=template&id=6871ccab&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=6871ccab&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6871ccab"]])

export default __exports__